/**
 * D57: removing something a gather or an import found AND a person confirmed is remembered (the server tombstones it so a
 * later run never suggests it again), so ask first. Plain words only: the name the person sees, never a table, id or URL.
 * Resolves true when the person chose Remove.
 */
import { Modal } from 'antd';

export function confirmRemoveGathered(name: string): Promise<boolean> {
  return new Promise((resolve) => {
    Modal.confirm({
      title: 'Remove this for good?',
      content: `"${name}" was found for this client and you confirmed it. Removing it also stops us suggesting it again.`,
      okText: 'Remove',
      cancelText: 'Keep',
      okButtonProps: { danger: true },
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}

/** A row a gather or an import wrote and a person confirmed. */
export function isConfirmedGathered(entry: { source?: string | null; verified_by?: string | null } | null | undefined): boolean {
  return !!entry && entry.source === 'discovered' && !!entry.verified_by;
}
